import React from 'react'
import { Form, Input, Spin, Table } from 'antd'

import PerfectScrollbar from 'libs/react-perfect-scrollbar'
import { EmptyData } from 'utils/ui'

import { withTranslation } from 'react-i18next'
import classNames from 'classnames'

import getTableInfo from 'pages/records/tableInfo/globalUsers'

import { safeboxClient } from 'myNet'
import search24SVG from '@/assets/images/toolbar-search-24.svg'
import iconClear20SVG from '@/assets/images/icon-clear-20.svg'

import styles from './style.module.scss'

const { Search } = Input

class UserListDef extends React.Component {
  state = {
    loading: false,
    groupData: null,
    checkedKeys: [],
    searchText: null,
  }

  formRef = React.createRef()

  scrollRef = React.createRef()

  filteredGroupMap = {}

  async componentDidMount() {
    this.reqData()
  }

  componentDidUpdate(/* prevProps, prevState */) {}

  componentWillUnmount() {}

  reqData = () => {
    this.setState({ loading: true })
    const { checkedKeys } = this.state
    const { excludeEmailList } = this.props

    safeboxClient.get('/v1/users').then((res) => {
      const { data } = res

      // excludeEmailList에 있는 id들을 제외한 데이터만 필터링
      const filteredData =
        data?.data?.filter((user) => ![...new Set(excludeEmailList)]?.includes(user.user_email)) ||
        []

      const validCheckedKeys = checkedKeys.filter((key) =>
        filteredData.some((user) => user.id === key),
      )

      this.setState({
        groupData: filteredData,
        loading: false,
        checkedKeys: validCheckedKeys, // 필터링된 키로 업데이트
      })
    })
  }

  notifyChecked = (checkedKeys) => {
    const { onSelectChanged } = this.props

    if (onSelectChanged != null) {
      const changedGroupList = checkedKeys.map((key) => this.filteredGroupMap[key])
      onSelectChanged(checkedKeys, changedGroupList)
    }
  }

  // search
  onSearch = (value) => {
    this.setState({ searchText: value || null })
    if (this.scrollRef.current != null) {
      this.scrollRef.current.element.scrollTop = 0
      this.scrollRef.current.update()
    }
  }

  onChange = (e) => {
    const { value } = e.target
    if (this.searchTimer != null) {
      clearTimeout(this.searchTimer)
    }

    this.searchTimer = setTimeout(() => {
      this.searchTimer = null
      this.onSearch(value)
    }, 300)
  }

  getTableData = (groupData, searchText, checkedKeys) => {
    const { excludeEmailList } = this.props

    const filteredGroupMap = {}

    console.log(' --- groupData : ', groupData)

    // 검색된 그룹만 필터링
    const filteredGroups = groupData?.filter((group) => {
      if (excludeEmailList != null && excludeEmailList.indexOf(group.id) > -1) {
        return false
      }

      // if (checkedKeys.includes(group.id)) {
      //   return false
      // }

      if (searchText != null && searchText.length > 0) {
        const { user_name: userName } = group
        if (userName.indexOf(searchText) < 0) {
          return false
        }
      }
      filteredGroupMap[group.id] = group // 검색된 데이터 추가
      return true
    })

    // 모든 그룹 데이터를 filteredGroupMap에 포함
    groupData.forEach((group) => {
      if (!filteredGroupMap[group.id]) {
        filteredGroupMap[group.id] = group
      }
    })

    this.filteredGroupMap = filteredGroupMap

    // UI에 표시할 체크된 항목만 필터링
    const filteredCheckedKeys = checkedKeys.filter((key) => filteredGroupMap[key] != null)

    return {
      tableData: filteredGroups,
      filteredCheckedKeys,
    }
  }

  render() {
    const { groupData, searchText, loading, checkedKeys } = this.state
    const { t } = this.props

    let userElems = <div style={{ height: '466px' }}>{null}</div>
    if (groupData != null) {
      const { tableData, filteredCheckedKeys } = this.getTableData(
        groupData,
        searchText,
        checkedKeys,
      )

      const onSelectChange = (selectedKeys) => {
        this.setState({ checkedKeys: selectedKeys })
        this.notifyChecked(selectedKeys)
      }

      const tableInfo = getTableInfo(styles, filteredCheckedKeys, onSelectChange)

      const tableAttrs = {
        className: classNames(styles.userTable, 'smallTable'),
        onRow: tableInfo.onRow,
        style: { overflow: 'auto' },
        pagination: false,
        showHeader: false,
        columns: tableInfo.columns,
        checkedKeys: filteredCheckedKeys,
        locale: {
          emptyText: <EmptyData type="member" />,
        },
        dataSource: tableData,
        rowKey: (record) => {
          return record.id
        },
      }

      userElems = <Table {...tableAttrs} />
    }

    const searchAttrs = {
      ref: this.searchRef,
      placeholder: t('workspace.search.placeholder'),
      onSearch: this.onSearch,
      prefix: <img src={search24SVG} alt="search" />,
      allowClear: { clearIcon: <img src={iconClear20SVG} alt="clear" /> },
      onChange: this.onChange,
    }

    return (
      <div className={classNames(styles.groupList, 'groupList')}>
        <Form component={false} ref={this.formRef}>
          <Form.Item name="val" noStyle>
            <Search {...searchAttrs} />
          </Form.Item>
        </Form>
        <Spin spinning={loading}>
          <PerfectScrollbar
            className={classNames(styles.groups)}
            refScroll={this.scrollRef}
            options={{
              suppressScrollX: true,
              wheelPropagation: false,
            }}
          >
            {userElems}
          </PerfectScrollbar>
        </Spin>
      </div>
    )
  }
}

const UserList = withTranslation()(UserListDef)

export default UserList
